/**
 * Ha quanto tempo um comprovante em analise espera (spec 071, 2.9). So pra mostrar na fila: quem lembra e o alerta do
 * backend, a uma vez por comprovante. A area promete a liberacao em ate 1 dia, por isso o destaque a partir de 24 h.
 */
const HORA = 3_600_000;

export function esperaDoComprovante(enviadoEm: string | Date, agora = new Date()): { texto: string; passou_de_24h: boolean } {
  const horas = Math.floor(Math.max(0, agora.getTime() - new Date(enviadoEm).getTime()) / HORA);
  if (horas < 1) return { texto: "menos de 1 h", passou_de_24h: false };
  if (horas < 24) return { texto: `${horas} h`, passou_de_24h: false };
  const dias = Math.floor(horas / 24);
  const resto = horas % 24;
  return { texto: `${dias} ${dias === 1 ? "dia" : "dias"}${resto ? ` e ${resto} h` : ""}`, passou_de_24h: true };
}
